<template>
  <div class="d-flex w-full align-center">
    <v-col cols="4">
      <div class="d-flex ml-n6 align-center">
        <v-btn icon dark class="mr-5" @click="updateModel(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <p class="ma-0">
          Detalhamento do Pedido
          <v-icon dark small class="mr-1">mdi-truck-delivery</v-icon>
          <span class="subtitle-2">{{`#${pedido.idpedido}`}}</span>
        </p>
      </div>
    </v-col>

    <v-col cols="4" class="d-flex justify-center">
      <div class="d-flex align-center">
        <v-select
          v-model="relatorios.selecionado"
          :items="relatorios.valores"
          label="Tipo de Relatório"
          item-text="text"
          item-value="id"
          return-object
          hide-details
          outlined
          dense
          dark
          style="width: 170px"
          :append-icon="`mdi-${relatorios.selecionado.icon}`"
        ></v-select>

        <v-btn
          color="success"
          class="ml-1"
          @click="gerarRelatorio()"
        >
          gerar
        </v-btn>

        <incluir-pedido-loja-drp
          v-if="pedido.status === 'POR EXPORTAR'"
          :pedido="pedido"
          class="ml-10"
          :small="false"
        />
      </div>
    </v-col>

    <v-col cols="4" class="d-flex">
      <v-spacer />

      <p class="ma-0 subtitle-2 mr-6">
        <span class="font-weight-bold">Data Emissão:</span>
        {{pedido.data_emissao}}
      </p>

      <p class="ma-0 subtitle-2">
        <span class="font-weight-bold">Status:</span>
        {{pedido.status }}
      </p>
    </v-col>
  </div>
</template>

<script>
import $axios from './../../../../api/api.js';
import IncluirPedidoLojaDrp from "../../separacaoDeMercadorias/exportacaoProtheus/IncluirPedidoLojaDrp";

export default {
  name: "TituloListaProdutosDoPedido",
  components: {IncluirPedidoLojaDrp},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    pedido: {
      type: Object,
      default: () => ({
        idpedido: '',
        data_emissao: '',
        status: ''
      })
    }
  },
  data: () => ({
    relatorios: {
      selecionado: null,
      valores: [
        {id: 'pdf', text: "PDF", icon: 'file-pdf-box', rota: 'relatorio_romaneio_drp2'},
        {id: 'excel', text: "EXCEL", icon: 'file-excel', rota: 'relatorio_romaneio_drp2_excel'},
        {id: 'csv', text: "CSV", icon: 'file-delimited', rota: 'relatorio_romaneio_drp2_csv'},
      ]
    }
  }),
  created() {
    this.relatorios.selecionado = this.relatorios.valores[0] || {};
  },
  methods: {
    updateModel(value) {
      this.$emit('update:modelValue', value);
    },
    gerarRelatorio() {
      const params = `?systock=grupo&token=${localStorage.token}&pedido=${this.pedido.idpedido}`;

      const URL_RELATORIO = `${$axios.defaults.baseURL}/${this.relatorios.selecionado.rota}?`

      window.open(URL_RELATORIO.concat(params), "_blank");
    }
  }
}
</script>

<style scoped>

</style>
